import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from './context/AuthContext';
import { ToasterProvider } from './context/ToasterContext';
import { I18nProvider } from './context/I18nContext';
import { SocketProvider } from './context/SocketContext';
import { LicenseBannerProvider } from './context/LicenseBannerContext';
import AppRoutes from './routes/AppRoutes';
import { handleUnauthorized } from './config/api';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes - keep data in cache for 10 minutes
      refetchOnMount: false, // Don't refetch on mount if data is fresh
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      retry: (failureCount, error) => {
        // Don't retry on 401 errors
        if (error?.response?.status === 401) {
          return false;
        }
        return failureCount < 1;
      },
    },
    mutations: {
      retry: (failureCount, error) => {
        // Don't retry on 401 errors
        if (error?.response?.status === 401) {
          return false;
        }
        return failureCount < 1;
      },
    },
  },
});

function App() {
  const [appLoading, setAppLoading] = useState(true);
  
  
  useEffect(() => {
    // Removed localStorage clearing to prevent interference with logout flow
    
    // Simulate app initialization
    setTimeout(() => {
      setAppLoading(false);
    }, 100);
  }, []);
  
  if (appLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Initializing Inchaa Admin...</p>
        </div>
      </div>
    );
  }
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <I18nProvider>
          <ToasterProvider>
            <AuthProvider>
              <LicenseBannerProvider>
                <SocketProvider>
                  <AppRoutes />
                </SocketProvider>
              </LicenseBannerProvider>
            </AuthProvider>
          </ToasterProvider>
        </I18nProvider>
      </Router>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}

export default App; 